
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-truck" })
export default class IconTruck extends Vue {}
